export default "__VITE_ASSET___5nOtl$1__"